// extracted by mini-css-extract-plugin
module.exports = {"separator":"style_separator__mFM3p"};